import { initializeVue } from "@/core/app-setup";
import TranslationStatus from "@/experiences/translation/views/TranslationStatus.vue";
window.initializeTranslationStatus = (elSelector, rootProps) => {
    return initializeVue(elSelector, TranslationStatus, { rootProps });
};
